import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import BulkList from 'components/BulkRequests/BulkList';
import BulkListHistory from 'components/BulkRequests/BulkListHistory';
import { useSearchParams } from 'react-router-dom';

function TabContainer({ children, tab, tabValue, dir }) {
  return (
    <div dir={dir}>
      {tab === tabValue && children}
    </div>
  );
}

const FullWidthTabsForBulk = (props) => {
  const [params] = useSearchParams()
  const [tabValue, setTabValue] = useState(Number(params.get("tab")) ? Number(params.get("tab")) : 0)

  const handleChange = (event, value) => {
    setTabValue(value)
  };

  return (
    <div className="w-100" >
      <AppBar position="static" color="default">
        <Tabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="on"
        >
          <Tab className="tab" label="Open" />
          <Tab className="tab" label="History" />
        </Tabs>
      </AppBar>
      <TabContainer dir="ltr" tab={0} tabValue={tabValue}>
        <BulkList tab={0} tabValue={tabValue} />
      </TabContainer>
      <TabContainer dir="ltr" tab={1} tabValue={tabValue}>
        <BulkListHistory tab={1} tabValue={tabValue} />
      </TabContainer>
    </div>
  );
}

export default FullWidthTabsForBulk